import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import DeleteCancel from '../../atoms/buttons/DeleteCancel';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { invokePostService, invokeGetService, setReRender } from "../../../store/global/actions";
import { useHistory } from "react-router-dom";

export default function UnnestChildTransaction({ element, onClose, onCompletion }) {


    console.log('element---tr--->', element)
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();
    const currentUrl = window.location.href;
    const [slug, blueprintID, tag, transactionId] = currentUrl.split('/').slice(4);



    const [isUnnesting, setIsUnnesting] = useState(false);

    let childTransactionId = element?.id;


    useEffect(() => {
        dispatch(invokeGetService('getTransactionAssociates', [element.id]))
            .then((response) => {
                console.log('resp---------_>', response)


            })
    }, [])

    const onUnnest = () => {
        setIsUnnesting(true)
        dispatch(invokePostService('unnestChildTransaction', {}, [childTransactionId]))
            .then((response) => {
                setIsUnnesting(false)
                dispatch(setReRender());
                onCompletion('Child transaction', 'unnest')
            })

    }


    return (
        <Grid container direction={"row"} spacing={1} >

            <Grid item xs={12}>
                <Typography variant="h6" >Unnest</Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Typography> Are you sure you want to unnnest the child transaction  ? </Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <DeleteCancel onDelete={onUnnest} onCancel={onClose} disableButton={isUnnesting} content={isUnnesting ? 'Unnesting..' : 'Unnest'} />
            </Grid>


        </Grid>
    )

}